import { render } from "./InviteUserDialog.vue?vue&type=template&id=b19f15ac&scoped=true"
import script from "./InviteUserDialog.vue?vue&type=script&lang=js"
export * from "./InviteUserDialog.vue?vue&type=script&lang=js"

import "./InviteUserDialog.vue?vue&type=style&index=0&id=b19f15ac&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19f15ac"]])

export default __exports__